import {
  Autocomplete,
  Grid,
  IconButton,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  TextField,
  Tooltip,
  Typography,
} from "@mui/material";
import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import {
  Button,
  Input,
  InputDate,
  InputQty,
  LabelComp,
  Select,
} from "../../../controls";
import { Alert, Form } from "../../../layout";
import { DropLi, Model, UseForm } from "../../../hooks";
import { Box } from "@mui/system";
import { useNavigate, useParams } from "react-router-dom";
import { ClearRounded } from "@mui/icons-material";
import * as actions from "../../../api/actions/pos";
import { connect } from "react-redux";
import { controller, endpoints } from "../../../api/actions/api";
import { useEffect } from "react";
import {
  MaxLength,
  NestedFormData,
  RmvArryEmptyProp,
} from "../../../hooks/Method";
import { safeOnComplete } from "../../../utils/safeOnComplete";
import { formatCurrency } from "../../../hooks/Currency";

const AddEditPurchReturn = (props) => {
  const { t } = useTranslation();
  const { _post, _put, _getById, _store, _getByObj, _authUser } = props;
  const { PurchReturnMdl } = Model();
  const navigate = useNavigate();
  const { ReturnReason } = DropLi();
  const { values, setValues, errors, setErrors, handleInpChg, handleInpDate } =
    UseForm(PurchReturnMdl);

  const [alert, setAlert] = useState({
    isOpen: false,
    type: "",
    title: "",
    subTitle: "",
  });
  const [, setFindErr] = useState("");
  const [searchVal, setSearchVal] = useState("");
  const [loading, setLoading] = useState(false);
  const [searchLi, setSearchLi] = useState([]);
  const [netAmount, setNetAmount] = useState(0);
  const [supplier, setSupplier] = useState("");
  const { id } = useParams();

  useEffect(() => {
    if (values.purchaseId) {
      const onComplete = (res) => {
        if (res.status !== 200) {
          setErrors((x) => ({ ...x, purchaseId: t("invalidReferenceNo") }));
          setValues((x) => ({ ...x, purchReturnItems: [] }));
        } else setErrors((x) => ({ ...x, purchaseId: "" }));

        setSupplier(res.result.supplier && res.result.supplier.company);
      };
      _getByObj(
        endpoints.Purchase + controller.GetById,
        {
          id: values.purchaseId,
          storeId: _store.id,
        },
        null,
        onComplete
      );
    } else {
      setSupplier("");
      setValues((x) => ({ ...x, purchReturnItems: [] }));
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [values.purchaseId, _store.id]);

  useEffect(() => {
    const subtotal = (values.purchReturnItems || []).reduce(
      (sum, item) =>
        sum + Number(item.qty || 0) * Number(item.purchPrice || 0),
      0
    );

    const discount =
      (Number(values.discount || 0) / 100) * subtotal;

    setNetAmount(subtotal - discount);
  }, [values.purchReturnItems, values.discount]);


  useEffect(() => {
    const onComplete = (res) => {
      if (
        res.status === 200 &&
        res.result.purchReturnItems &&
        res.result.purchReturnItems.length > 0
      ) {
        setValues({
          ...res.result,
          purchReturnItems: res.result.purchReturnItems.map((j) => {
            var purchData = res.result.purchase.purchItems.find(
              (x) => x.productId === j.productId
            );
            j.purchPrice = purchData
              ? purchData.purchPrice
              : j.product.purchPrice;
            j.returnReason = j.returnReason === 0 ? "" : j.returnReason;
            purchData && (j.purchQty = purchData.qty);
            return j;
          }),
        });
        setSupplier(res.result.purchase.supplier.company);
      }
    };

    if (id && _store.id)
      _getByObj(
        endpoints.PurchReturn + controller.GetById,
        { id: id, storeId: _store.id },
        null,
        onComplete
      );
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [id, _store.id]);

  const validateForm = () => {
    let temp = {};
    temp.purchaseId =
      values.purchaseId !== "" ? "" : t("referenceNoRequired");

    setErrors({ ...temp });
    return Object.values(temp).every((x) => x === "");
  };

  const handleSubmit = () => {
    if (
      validateForm() &&
      values.purchReturnItems &&
      values.purchReturnItems.length > 0
    ) {
      // setLoading(true);
      const onComplete = (res) => {
        setLoading(false);
        res.status === 201 || res.status === 200
          ? _getById(
              endpoints.PurchReturn + controller.GetByStore,
              _store.id,
              actions.ActionType.List,
              navigate("/purchases-return")
            )
          : setAlert({
              isOpen: true,
              type: "error",
              title: t("error"),
              subTitle: res.msg,
            });
      };
      values.userId = _authUser.id;
      if (id) {
        _put(
          endpoints.PurchReturn,
          NestedFormData(RmvArryEmptyProp(values)),
          null,
          onComplete
        );
      } else {
        values.storeId = _store.id;
        _post(
          endpoints.PurchReturn,
          NestedFormData(RmvArryEmptyProp(values)),
          null,
          onComplete
        );
      }
    } else if (values.purchReturnItems && values.purchReturnItems <= 0)
      setAlert({
        isOpen: true,
        type: "error",
        title: t("emptyReturnList"),
        subTitle: t("emptyReturnListMessage"),
      });
  };

  const GetDataFromServer = (val, onComplete) => {
    // Get Data From Server
    val &&
      _getByObj(
        endpoints.PurchReturn + controller.FindProducts,
        {
          id: values.purchaseId,
          value: val,
        },
        null,
        onComplete
      );
  };

  const handleSearch = (e, val) => {
    setSearchVal(val);
    const onComplete = (res) => {
      res.status === 200 &&
        res.result &&
        setSearchLi([
          ...res.result.map((j) => {
            return {
              ...j.product,
              id: j.product.id,
              label: `${j.product.name} (${j.product.barcode})`,
              purchQty: j.qty,
              purchPrice: j.purchPrice,
            };
          }),
        ]);
    };
    e && GetDataFromServer(e.target.value, onComplete);
  };

//
    const handleScan = (e) => {
      const value = e.target.value;

      const onComplete = safeOnComplete(
        (res) => {
          if (
            res.status === 200 &&
            Array.isArray(res.result) &&
            res.result.length > 0
          ) {
            const val = res.result.find(
              (j) => j.product?.barcode === searchVal
            );

            if (val && val.product) {
              val.product.purchQty = val.qty;
              handleSelect(null, val.product);
            } else {
              setFindErr(t("productNotFound"));
            }
          } else {
            setFindErr(t("productNotFound"));
          }
        },
        (err) => {
          setFindErr(err?.msg ?? t("productLookupFailed"));
        }
      );

      GetDataFromServer(value, onComplete);
      setSearchVal("");
    };
//
  const handleSelect = (e, product) => {
    if (product) {
      if (!values.purchReturnItems.some((j) => j.productId === product.id)) {
        setValues((x) => ({
          ...x,
          purchReturnItems: [
            {
              productId: product.id,
              qty: 1,
              purchQty: product.purchQty,
              purchPrice: product.purchPrice,
              product: product,
              returnReason: "",
            },
            ...x.purchReturnItems,
          ],
        }));
      } else if (
        values.purchReturnItems.some((j) => j.productId === product.id)
      ) {
        setValues((x) => ({
          ...x,
          purchReturnItems: x.purchReturnItems.map((j) =>
            j.productId === product.id
              ? {
                  ...j,
                  qty:
                    parseInt(j.qty) + 1 <= j.purchQty
                      ? parseInt(j.qty) + 1
                      : j.qty,
                }
              : j
          ),
        }));
      }
    }
    setSearchVal("");
  };

  const handleQtyChg = (e, productId) => {
    setValues((x) => ({
      ...x,
      purchReturnItems: x.purchReturnItems.map((j) =>
        j.productId === productId
          ? {
              ...j,
              qty:
                Math.abs(e.target.value) <= j.purchQty ? e.target.value : j.qty,
            }
          : j
      ),
    }));
  };

  const handleInc = (productId) => {
    setValues((x) => ({
      ...x,
      purchReturnItems: x.purchReturnItems.map((j) =>
        j.productId === productId
          ? {
              ...j,
              qty:
                parseInt(j.qty) + 1 <= j.purchQty ? parseInt(j.qty) + 1 : j.qty,
            }
          : j
      ),
    }));
  };
  const handleDec = (productId) => {
    setValues((x) => ({
      ...x,
      purchReturnItems: x.purchReturnItems.map((j) =>
        j.productId === productId
          ? { ...j, qty: j.qty > 1 ? parseInt(j.qty) - 1 : j.qty }
          : j
      ),
    }));
  };

  const handleRmvItem = (prodId) => {
    setValues((x) => ({
      ...x,
      purchReturnItems: x.purchReturnItems.filter(
        (j) => j.productId !== prodId
      ),
    }));
  };

  const handleReason = (e, productId) => {
    setValues((x) => ({
      ...x,
      purchReturnItems: x.purchReturnItems.map((j) =>
        j.productId === productId ? { ...j, returnReason: e.target.value } : j
      ),
    }));
  };

  return (
    <>
      <Form noValidate>
        <Box className="tx-center p-20">
          <Typography variant="h5" className="fs-26 gray-color fw-5 tx-upp">
            {t("purchaseReturn")}
          </Typography>
          <div className="bs-bottom mx-w-80 mt-5 m-auto" />
        </Box>
        {/* Purchase Details */}
        <div className="pt-20" />
        <Paper className="br-8 shadow-xs p-20">
          <Grid container spacing={2}>
            <Grid item xs={12} md={3}>
              <Input
                disabled={id === undefined ? false : true}
                label={t("referenceNo")}
                className="rmv-arrow"
                name="purchaseId"
                type="number"
                onInput={(e) => (e.target.value = MaxLength(e.target.value, 8))}
                value={values.purchaseId}
                error={errors.purchaseId}
                onChange={handleInpChg}
                fullWidth
              />
            </Grid>
            <Grid item xs={12} md={6}>
              <LabelComp label={t("supplier")} value={supplier} />
            </Grid>
            <Grid item xs={12} md={3}>
              <InputDate
                label={t("returnDate")}
                name="returnDate"
                value={values.returnDate}
                error={errors.returnDate}
                onChange={(date) =>
                  handleInpDate("returnDate", new Date(date).toLocaleString())
                }
                fullWidth
              />
            </Grid>
          </Grid>
        </Paper>

        {/* Items */}
        <div className="pt-20" />
        <Paper className="br-8 shadow-xs p-20">
          {/* Title Bar */}
          <Box className="d-flex j-between">
            <Typography
              variant="subtitle1"
              className="fs-18 fw-5 gray-color pl-10 mb-20"
              sx={{ borderLeft: "5px double var(--primary-color)" }}
            >
              {t("returnPurchases")}
            </Typography>
          </Box>

          {/* Search Box */}
          <Autocomplete
            id="searchBox"
            disabled={supplier ? false : true}
            options={searchLi}
            onChange={handleSelect}
            inputValue={searchVal}
            onInputChange={handleSearch}
            isOptionEqualToValue={(opt, val) => opt.id === val.id}
            onKeyDown={(e) => e.which === 13 && handleScan(e, searchVal)}
            classes={{ paper: "shadow-sm" }}
            renderInput={(params) => (
              <TextField
                variant="filled"
                label={t("searchByNameOrBarcode")}
                {...params}
              />
            )}
          />

          {/* Product Details */}
          <TableContainer className="mt-20">
            <Table size="small" aria-label="a dense table">
              <TableHead>
                <TableRow>
                  <TableCell>{t("action")}</TableCell>
                  <TableCell>{t("productName")}</TableCell>
                  <TableCell>{t("returnReason")}</TableCell>
                  <TableCell>{t("quantity")}</TableCell>
                  <TableCell>{t("purchasePrice")}</TableCell>
                  <TableCell>{t("subtotal")}</TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {values.purchReturnItems &&
                  values.purchReturnItems.map((prod, index) => (
                    <TableRow key={index}>
                      <TableCell>
                        <Tooltip arrow title={t("delete")}>
                          <IconButton
                            onClick={() => handleRmvItem(prod.productId)}
                            size="small"
                            className="btn-error"
                          >
                            <ClearRounded className="fs-14" />
                          </IconButton>
                        </Tooltip>
                      </TableCell>
                      <TableCell>{prod.product && prod.product.name}</TableCell>
                      <TableCell sx={{ minWidth: "80px" }}>
                        <Select
                          variant="outlined"
                          name="returnReason"
                          size="small"
                          fullWidth
                          value={prod.returnReason}
                          onChange={(e) => handleReason(e, prod.productId)}
                          options={ReturnReason}
                          sx={{
                            "& .MuiInputBase-root": {
                              padding: "0px 0px",
                            },
                            "& .MuiInputBase-input": {
                              padding: "5.5px 0px",
                              textAlign: "center",
                            },
                          }}
                        />
                      </TableCell>
                      <TableCell>
                        <InputQty
                          value={prod.qty}
                          onIncrease={() => handleInc(prod.productId)}
                          onDecrease={() => handleDec(prod.productId)}
                          onChange={(e) => handleQtyChg(e, prod.productId)}
                        />
                      </TableCell>

                      <TableCell className="fs-16">
                        {formatCurrency(prod.purchPrice, _store)}
                      </TableCell>

                      <TableCell className="fs-16">
                        {formatCurrency(prod.qty * prod.purchPrice, _store)}
                      </TableCell>
                    </TableRow>
                  ))}
              </TableBody>
            </Table>
            <Box className="tx-right p-10 tx-upp">
              <Typography className="fs-16 gray-color fw-5">
                {t("totalItem")}:&nbsp;
                {values.purchReturnItems && values.purchReturnItems.length > 0
                  ? values.purchReturnItems
                      .map((j) => j.qty)
                      .reduce((x, y) => x + y, 0)
                  : 0}
              </Typography>
              <Typography className="fs-20 gray-color fw-6">
                {t("netAmount")}: {formatCurrency(netAmount, _store)}
              </Typography>
            </Box>
          </TableContainer>
        </Paper>

        <Grid item xs={12} className="tx-right mt-20">
          <Button
            loading={loading}
            onClick={handleSubmit}
            sx={{ width: { md: "200px", xs: "100%" } }}
            size="large"
          >
            {id ? t("saveChanges") : t("submit")}
          </Button>
        </Grid>
      </Form>
      {/* Alert  */}
      <Alert alert={alert} setAlert={setAlert} />
    </>
  );
};

const mapStateToProps = (state) => ({
  _data: state.pos.data,
  _stores: state.pos.stores,
  _store: state.pos.defStore,
  _authUser: state.pos.authUser,
});

const mapActionToProps = {
  _post: actions.post,
  _put: actions.put,
  _getById: actions.getById,
  _getByObj: actions.getByObj,
  _get: actions.get,
  _clear: actions.clear,
};

export default connect(mapStateToProps, mapActionToProps)(AddEditPurchReturn);
